import { CSSProperties } from 'react';

export interface IHeaderOptions {
  showDiscount?: boolean;
  showHamburger?: boolean;
  showBack?: boolean;
  showLogo?: boolean;
  showSearch?: boolean;
  showCart?: boolean;
  headerMerge?: boolean;
  showBottomBorder?: boolean;
  showLogoOnLeft?: boolean;
  headerStyles?: CSSProperties;
  showWishlist?: boolean;
}

export enum BOTTOM_NAV_STATE {
  HOME = 'Home',
  SHOP = 'Shop',
  MY_ACCOUNT = 'My Account',
  OFFER = 'Offer',
}

export interface IBottomNavOptions {
  showBottomNav: boolean;
  selectedBottomNavState?: BOTTOM_NAV_STATE;
}

export type AppState = Readonly<{
  statusCode: number;
  headerOptions: IHeaderOptions;
  headerDiscount: string;
  menu: {
    isFetching: boolean;
    isError: boolean;
    data: any;
  };
  user: {
    isFetching: boolean;
    isError: boolean;
    cartCount: number;
    base_location: string;
    customerData: {
      id: string;
      email: string;
      mobile: string;
      firstName: string;
      lastName: string;
      hideEmail: boolean;
      allowMergeAccount: boolean;
    } | null;
    formKey: string;
    hasOptedForNewsletter: string;
  };
  ssrHeaders: {
    [key: string]: string;
  };
  cookies: {
    [key: string]: string;
  };
  showHeader: boolean;
  showFooter: boolean;
  showFooterDownloadAppSection: boolean;
  inProgress: boolean;
  webAppType: string;
  showLoginOption: boolean;
  searchTerm: string;
  redirectURL?: string;
  baseCountry: string;
  showSuccessLoginToast: boolean;
  bottomNavOptions: IBottomNavOptions;
}>;

export interface IAction {
  type: string;
  payload: any;
}
